import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useTags } from '../../../hooks/WPHooks';
import { ModelsService } from '../../../services/ModelsService';
import { ParametersProps } from '../../wizard/WizardSteps';

export const InterstsParameters: React.FC<ParametersProps> = ({
  user,
  parameters,
  updateParameter,
  isSetLoading,
}) => {
  const { tags: hobbies } = useTags('interest');

  useEffect(() => {
    if (hobbies.length > 0) {
      isSetLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hobbies]);

  const changeUserHobbies = (event, hobbyId) => {
    if (event.target.checked) {
      return [...parameters.interest, hobbyId];
    } else {
      return [...parameters.interest.filter((hobby) => hobby !== hobbyId)];
    }
  };

  const onChangeTags = (event, hobbyId) => {
    if (user) {
      const newInterests = changeUserHobbies(event, hobbyId);
      updateParameter('interest', newInterests);
    }
  };

  if (hobbies.length > 0) {
    return (
      <div>
        <ul>
          {hobbies.map((hobby, index) => (
            <li
              key={'hobby_' + index}
              className="flex flex-row justify-between py-3"
            >
              <span className="text-black">
                {ModelsService.getTranslationFromTerm(hobby, user.acf.locale)}
              </span>
              <input
                className="w-6 h-6 text-primary border-lightGrey appearance-none bg-white checked:bg-primary focus:ring-transparent  active:bg-primary rounded-full"
                type="checkbox"
                onChange={(event) => onChangeTags(event, hobby.id)}
                checked={parameters.interest.includes(hobby.id)}
              />
            </li>
          ))}
        </ul>
      </div>
    );
  } else {
    return (
      <p className="text-center w-full text-primary font-bold">
        <FormattedMessage id="Loading" />
      </p>
    );
  }
};
